import { render, staticRenderFns } from "./DoughnutChartPagamento.vue?vue&type=template&id=6714005a"
import script from "./DoughnutChartPagamento.vue?vue&type=script&lang=js"
export * from "./DoughnutChartPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports